import querystring from "qs";

const PAGE_LIMIT = 50;

interface IQuery {
    __limit: number;
    "__buyers.__ref"?: any;
    __fields: string;
}

export const getContactsForWhiteboard = (data, boardId) => {
    const { filters } = data;
    const query: IQuery = {
        "__buyers.__ref": filters["__buyers.__ref"],
        __fields: "__buyers",
        __limit: PAGE_LIMIT,
    };

    return {
        force: true,
        url: `/api/v3.0/companies?${querystring.stringify(query)}`,
    };
};
